import { render, staticRenderFns } from "./ReportManager.vue?vue&type=template&id=2dd29faa&scoped=true&"
import script from "./ReportManager.vue?vue&type=script&lang=js&"
export * from "./ReportManager.vue?vue&type=script&lang=js&"
import style0 from "./ReportManager.vue?vue&type=style&index=0&id=2dd29faa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd29faa",
  null
  
)

export default component.exports